import { useListWorkflowsQuery } from 'API/order/workflow/WorkflowsAPI';
import { WorkflowsTable } from 'components/order/workflow/WorkflowsTable';
import { Show } from 'components/shared/Show';
import React from 'react';
import { useParams } from 'react-router-dom';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { CardTW } from 'tailwindComponents/CardTW/CardTW';
import { ErrorMessageTW } from 'tailwindComponents/errorMessage/ErrorMessageTW';
import { UUID } from 'types/shared/UUID';
import { FormCell, Header2Text } from 'ui-toolkit';
import { useSetOrderNavigationTab } from 'utilities/hooks/useSetOrderNavigationTab';

export const WorkflowContainer: React.FC = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Workflow });
  const { orderId } = useParams<{ orderId: UUID }>();

  const { data: workflows = [], error: workflowsFetchError } = useListWorkflowsQuery({ orderId });

  return (
    <>
      <ErrorMessageTW rtkError={workflowsFetchError} />
      <CardTW>
        <FormCell hintText={'Shows the current status of the workflows associated with this order.'}>
          <Header2Text>Workflows</Header2Text>
        </FormCell>
        <Show when={workflows.length === 0} fallback={<WorkflowsTable workflows={workflows} />}>
          <div className="grid h-48 grid-cols-1 place-content-center">
            <h3 className="justify-self-center pt-8">There are no active workflows for this order</h3>
          </div>
        </Show>
      </CardTW>
    </>
  );
};
